var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79476 12.358H5.08951V15L8.39179 12.358H11.5633C12.2773 12.358 12.858 11.7773 12.858 11.0633V5.88423C12.858 5.17018 12.2773 4.58948 11.5633 4.58948H3.79476C3.0807 4.58948 2.5 5.17018 2.5 5.88423V11.0633C2.5 11.7773 3.0807 12.358 3.79476 12.358Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1531 2H6.3846C5.67054 2 5.08984 2.5807 5.08984 3.29476H12.8584C13.5724 3.29476 14.1531 3.87545 14.1531 4.58951V9.76853C14.8672 9.76853 15.4479 9.18784 15.4479 8.47378V3.29476C15.4479 2.5807 14.8672 2 14.1531 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/Chat_white.b615dd4271e9044ccd565add337c537b.svg";
export { ForwardRef as ReactComponent };